export type EditCameraSaveProgressHandlers = {
  setProgressPercent?: (percent: number | undefined) => void;
  setProgressMessage?: (message: string) => void;
};

export const clearEditCameraSaveProgress = (
  handlers?: EditCameraSaveProgressHandlers
) => {
  handlers?.setProgressPercent?.(undefined);
  handlers?.setProgressMessage?.("");
};

export const reportEditCameraSaveProgress = (
  handlers: EditCameraSaveProgressHandlers | undefined,
  percent: number,
  message: string
) => {
  handlers?.setProgressPercent?.(percent);
  handlers?.setProgressMessage?.(message);
};

export const reportEditCameraSaveStart = (
  handlers?: EditCameraSaveProgressHandlers
) => {
  reportEditCameraSaveProgress(handlers, 10, "Saving changes...");
};

export const reportProductMetricsSaveProgress = (
  handlers: EditCameraSaveProgressHandlers | undefined,
  completed: number,
  total: number
) => {
  if (total <= 0) {
    reportEditCameraSaveProgress(handlers, 50, "Updating products...");
    return;
  }
  const percent = Math.min(
    85,
    Math.round(15 + (completed / total) * 70)
  );
  const message =
    total === 1
      ? "Updating products..."
      : `Updating products (${completed} of ${total})...`;
  reportEditCameraSaveProgress(handlers, percent, message);
};

export const reportEditCameraSaveRefreshing = (
  handlers?: EditCameraSaveProgressHandlers
) => {
  reportEditCameraSaveProgress(handlers, 90, "Refreshing camera data...");
};
